import { IconArrowTopRight } from '@spotify-internal/encore-web';
import React from 'react';

export const NavArrowIcon = (): JSX.Element => {
  // whitespace required to align svg to text baseline
  return (
    <span>
      {' '}
      <IconArrowTopRight iconSize={16} aria-label="Open in new tab" />
    </span>
  );
};
